import { NavLink, Outlet } from "react-router-dom"
import { DashboardLayout } from "../../layouts/DashboardLayout"
import {
  ChartBarIcon,
  UsersIcon,
  AcademicCapIcon,
  BriefcaseIcon,
  BuildingOffice2Icon,
  UserGroupIcon,
} from "@heroicons/react/16/solid"

const TABS = [
  { to: "/admin/analytics/overview",      label: "Обзор",       icon: <ChartBarIcon className="w-3.5 h-3.5" /> },
  { to: "/admin/analytics/users",         label: "Пользователи",icon: <UsersIcon className="w-3.5 h-3.5" /> },
  { to: "/admin/analytics/courses",       label: "Курсы",       icon: <AcademicCapIcon className="w-3.5 h-3.5" /> },
  { to: "/admin/analytics/mentors",       label: "Менторы",     icon: <UserGroupIcon className="w-3.5 h-3.5" /> },
  { to: "/admin/analytics/vacancies",     label: "Вакансии",    icon: <BriefcaseIcon className="w-3.5 h-3.5" /> },
  { to: "/admin/analytics/china",         label: "Компании Китая", icon: <BuildingOffice2Icon className="w-3.5 h-3.5" /> },
]

export const AnalyticsLayout = () => (
  <DashboardLayout title="Аналитика">
    <div className="space-y-5">
      {/* Tab bar */}
      <div className="flex items-center gap-1 bg-white border border-gray-100 rounded-xl p-1 overflow-x-auto">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              `flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all ${
                isActive
                  ? "bg-blue-600 text-white shadow-sm"
                  : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className={isActive ? "text-white" : "text-gray-400"}>{tab.icon}</span>
                {tab.label}
              </>
            )}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  </DashboardLayout>
)
